import { useMemo } from "react";

import { caseConstants } from "@_constants/case.constants";
import { isNull, validateEmail } from "@_utils/helpers";

export const useOverviewValidation = ({ data, languageReducer }) =>
  useMemo(() => {
    const validTranslation =
      languageReducer.translations.default_translation_id;
    const flowId = data.email_flow?.id;
    const flow = flowId ? data.email_flow : undefined;

    const taxType = data.claim_details.indirect_tax_type;
    const taxPercentage = data.claim_details.indirect_tax_percentage;
    const isTaxable =
      taxType &&
      taxType !== caseConstants.CASE_TAX_TYPE_NO_INDIRECT_TAX &&
      taxType !== caseConstants.CASE_TAX_TYPE_REVERSE_CHARGE;
    const validTax =
      !isTaxable || (taxPercentage !== null && taxPercentage >= 0);

    const validContact =
      data.opponent_contact_details?.email &&
      !isNull(data.opponent_contact_details?.email) &&
      validateEmail(data.opponent_contact_details?.email);

    const hasNetAmountFindings =
      data.charge_details?.total_net_amount_findings > 0;
    const hasValidSettlementOffer =
      (data.claim_details.settlement_offer_date &&
        data.claim_details.settlement_offer_percentage) ||
      (!data.claim_details.settlement_offer_date &&
        !data.claim_details.settlement_offer_percentage);
    const hasValidCountry = data.country && !isNull(data.country);
    const hasValidFindings = !data.findings.some(
      (item) => !item.price || item.price <= 0,
    );
    const hasValidAdditionalFees =
      !data.claim_details.additional_fees ||
      !data.claim_details.additional_fees.some(
        (item) => !item.percentage || !item.name || item.price <= 0,
      );
    const hasChargeCurrency = data.charge_details?.currency;
    const hasIndirectTaxType = data.charge_details?.indirect_tax_type;

    const validClaim =
      hasNetAmountFindings &&
      hasValidSettlementOffer &&
      hasValidCountry &&
      hasValidFindings &&
      hasValidAdditionalFees &&
      hasChargeCurrency &&
      hasIndirectTaxType &&
      validTax;

    const activable = validContact && validClaim && flow && validTranslation;

    return {
      validTranslation,
      flowId,
      flow,
      taxType,
      taxPercentage,
      isTaxable,
      validTax,
      validContact,
      hasNetAmountFindings,
      hasValidSettlementOffer,
      hasValidCountry,
      hasValidFindings,
      hasValidAdditionalFees,
      hasChargeCurrency,
      hasIndirectTaxType,
      validClaim,
      activable,
    };
  }, [data, languageReducer]);
